import {apolloClient} from "seu-frontend/graphql/apollo";
import INIT from "./init.gql"
import LIST_LANGUAGES from "../init/listLanguages.gql"

const init = () => {
  return apolloClient.query({
    query: INIT,
  }).then(({data}) => data)
};

const listLanguages = () => {
  return apolloClient.query({
    query: LIST_LANGUAGES,
  }).then(({data: {languages}}) => languages)
};

export {
  init,
  listLanguages
}
